import { determinePageName } from './consentHelpers';

const mockAnalytics = {
  track: () => {},
  page: () => {},
  identify: () => {},
};

if (typeof window !== 'undefined') {
  (window as any).determinePageName = determinePageName;

  (window as any).initializeSegmentAnalytics = () => {
    const writeKey = process.env.REACT_APP_SEGMENT_WRITE_KEY;
    
    if (!writeKey) {
      console.error('No write key found!');
      return mockAnalytics;
    }
    
    if ((window as any).analytics && !(window as any).analytics.invoked) {
      return (window as any).analytics;
    }

    const analytics = (window as any).analytics = 
      (window as any).analytics || [];
    
    if (!analytics.initialize) {
      if (analytics.invoked) {
        return analytics;
      }
      
      analytics.invoked = true;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on'
      ];
      
      analytics.factory = function(method: string) {
        return function() {
          const args = Array.prototype.slice.call(arguments);
          args.unshift(method);
          analytics.push(args);
          return analytics;
        };
      };
      
      for (let i = 0; i < analytics.methods.length; i++) {
        const key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
      }
      
      analytics.load = function(key: string) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 
          `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;
        script.onerror = (e) => 
          console.error('Segment script failed to load', e);
        const first = document.getElementsByTagName('script')[0];
        first?.parentNode?.insertBefore(script, first);
      };
      
      analytics.SNIPPET_VERSION = '4.15.3';
      analytics.load(writeKey);
      
      (window as any).segmentAnalytics = analytics;
      
      // Polling until the real Segment instance loads
      const waitForSegment = setInterval(() => {
        if (!Array.isArray((window as any).analytics)) {
          clearInterval(waitForSegment);
          
          (window as any).segmentAnalytics = (window as any).analytics;

          if ((window as any).analyticsConsentGranted) {
            const pageName = determinePageName();
            if (pageName) {
              (window as any).analytics.page(pageName);
              (window as any).lastPageTracked = {
                name: pageName,
                timestamp: Date.now()
              };
            }
          }
        }
      }, 100);
      
      // Safety timeout
      setTimeout(() => {
        clearInterval(waitForSegment);
      }, 10000);
    }
    
    return analytics;
  };
}

const analyticsProxy = {
  track: (event: string, properties?: any) => {
    const current = (window as any).segmentAnalytics || mockAnalytics;
    return current.track(event, properties);
  },
  page: (name?: string, properties?: any) => {
    const current = (window as any).segmentAnalytics || mockAnalytics;
    return current.page(name, properties);
  },
  identify: (userId?: string, traits?: any) => {
    const current = (window as any).segmentAnalytics || mockAnalytics;
    return current.identify(userId, traits);
  }
};

export default analyticsProxy;